import { useWindowSize } from "@react-hookz/web";
import { BreakpointClass, useBreakpointClass } from "./breakpoints";

export function useIsMobileSize() {
  return useBreakpointClass() === BreakpointClass.XSMALL;
}

// For use by sidebar and sidebar-related components only.
export function useIsMobileSizeForSidebar() {
  return useWindowSize().width < 800;
}

// For use by sidebar and sidebar-related components only.
// Takes into account the height of the screen, useful for Hornet.
export function useIsSmallSizeForSidebar() {
  const windowSize = useWindowSize();
  return (
    windowSize.width < 800 ||
    (windowSize.height < 650 && windowSize.width < 1000)
  );
}
